import { ChangeDetectionStrategy, Component, input, output, inject } from '@angular/core';
import { DirectsState } from '@coin/shared/auth/feature';
import { environment } from '@coin/shared/core/util-environments';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-apps',
  templateUrl: './apps.component.html',
  styleUrls: ['./apps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class AppsComponent {
  private store = inject(Store);

  // eslint-disable-next-line @angular-eslint/no-output-native
  toggle = output();
  closeMenu = output();
  isExpanded = input(false);

  isLineManager$ = this.store.select(DirectsState.isLineManager);

  public environment = environment;
}
